module.exports = __webpack_public_path__ + "img/6.3087c603.png";